<template>
  <div v-if="address">
    <div class="form-group">
      <label>{{ 'att_contact' | t }}</label>
      <input class="form-control" v-model="address.att_contact" required="required" />
    </div>
    <div class="form-group">
      <label>{{ 'company_name' | t }}</label>
      <input class="form-control" v-model="address.company_name" />
    </div>
    <div class="form-group">
      <label>{{ 'address_1' | t }}</label>
      <input class="form-control" v-model="address.address_1" required="required" />
    </div>
    <div class="form-group">
      <label>{{ 'address_2' | t }}</label>
      <input class="form-control" v-model="address.address_2" />
    </div>
    <div class="form-group">
      <label>{{ 'country' | t }}</label>
      <select class="form-control" v-model="address.country_code" required="required">
        <option v-for="c in countries" :value="c.code">{{ c.name }}</option>
      </select>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>{{ 'zip' | t }}</label>
          <input class="form-control" v-model="address.zip" required="required" />
        </div>
      </div>
      <div class="col-sm-9">
        <div class="form-group">
          <label>{{ 'city' | t }}</label>
          <input class="form-control" v-model="address.city" required="required" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let global_countries = require('i18n-iso-countries');
import zipcodes from '@/utils/danish-zip-codes.js';
import config from '@/config';

export default {
  props: ['address'],
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    countries: function () {
      var cs = global_countries.getNames(config.locale);
      return _.chain(cs)
        .map((name, code) => {
          return { code: code, name: name };
        })
        .sortBy(['name', 'asc'])
        .unshift({ code: '', name: '' })
        .unshift({ code: 'DK', name: cs.DK })
        .unshift({ code: 'GB', name: cs.GB })
        .value();
    },
    city: function () {
      return zipcodes[this.shipment.delivery_address.zip];
    }
  },
  watch: {
    'address.zip': function () {
      console.log('zip', this.address.zip, zipcodes[this.address.zip], this.address.country_code);
      let city = zipcodes[this.address.zip];
      if (city && this.address.country_code === 'DK') {
        this.address.city = city;
      }
    }
  }
};
</script>

<style scoped></style>
